<div class="signup-wrap">
  <div class="signup-wrap__inner">
    <div class="signup">
      <div class="signup__intro">
        <h2 class="signup__intro-title">Upgrade Your Plan</h2>
        <p class="signup__intro-text">You are currently subscribed to our Basic Plan. Upgrade to the Standard Plan and get access to more features!</p>
      </div>
      <app-plan planType="PeerComparisonStandard" [upgrade]="true" [highlighted]="true"></app-plan>
      <app-plan planType="PeerComparisonBasic" [upgrade]="true"></app-plan>
    </div>
  </div>
</div>
